module.exports = __webpack_public_path__ + "files/d356c6f07d602526d563b304b2dd5c79.png";